import { useMemo } from 'react';

import { getActivePreferenceQuestionStepIds } from '@/features/guided-financial-planning/config';
import { useGuidedPlanningFlatStepConfigs } from '@/features/guided-financial-planning/context';

export function usePreferenceQuestionProgress(stepId: string) {
  const flatStepConfigs = useGuidedPlanningFlatStepConfigs();

  return useMemo(() => {
    const ids = getActivePreferenceQuestionStepIds(flatStepConfigs);
    const zeroBased = ids.indexOf(stepId);
    return {
      questionNumber: zeroBased >= 0 ? zeroBased + 1 : 1,
      questionTotal: Math.max(ids.length, 1),
      activeDotIndex: zeroBased >= 0 ? zeroBased : 0,
    };
  }, [flatStepConfigs, stepId]);
}
